export const BASE_URL = '/api'
export const EPP_DOMAIN = BASE_URL + '/epp/domain'
export const REGISTRY_DOMAINS = BASE_URL + '/registry/domains'
